import { jsx as _jsx } from "react/jsx-runtime";
import styles from './anchor-mark.module.scss';
export const AnchorMark = ({ anchorId, offset })=>/*#__PURE__*/ _jsx("span", {
        className: styles['anchor-mark'],
        id: anchorId,
        style: {
            top: offset
        }
    });

//# sourceMappingURL=AnchorMark.js.map